console.log("Checkout popup script loaded");

const CheckoutPopupStorageKey = 'nw-checkout-popup-display-datetime';
const CheckoutPopupBackground = 'nw-checkout-popup-background';
const CheckoutPopupContainer = 'nw-checkout-popup-container';


const CheckoutPopupFreeShipKey = '#main-cart-footer .freeShippingWidget .progress-bar';
const CheckoutPopupFreeShipValueKey = 'aria-valuenow';
const CheckoutPopupFreeShipWidgetKey = '#main-cart-footer .freeShippingWidget';

var CheckoutPopupIsOpen = false;

var CheckoutPopupBackgroundElement;
var CheckoutPopupContainerElement;

var CheckoutPopupOriginButton;
var CheckoutPopupBoundButtons;

function CheckoutPopupBindClick() {
    const selectors = ['button#checkout'];
    const selectorString = selectors.join(', ');
    CheckoutPopupBoundButtons = document.querySelectorAll(selectorString);

    CheckoutPopupWireUpDynamicElements();

    console.log('CheckoutPopupWireUpDynamicElements Completed');

}

function CheckoutPopupCheckoutButtonPressed(event, element)
{
    //temp to see if its firing
    //event.preventDefault();
    //event.stopPropagation();

    console.log('Checkout button element: ' + element);

    CheckoutPopupOriginButton = element;

    console.log("Starting CheckoutPopupTimerExpired");

    if(CheckoutPopupTimerExpired() == false) return;

    var logicResult = CheckoutPopupPrimeLogic();

    if(logicResult == true)
    {
        event.preventDefault();
        event.stopPropagation();
        console.log("Yes need to show the popup");
    }
    else
    {
        console.log("No need to show the popup");
        //element.form.submit();
    }
}

function CheckoutPopupWireUpDynamicElements()
{
    CheckoutPopupBackgroundElement = document.querySelector('.nw-checkout-popup-background');
    CheckoutPopupContainerElement = document.querySelector('.nw-checkout-popup-container');

    console.log("CheckoutPopupContainerElement is null, no rendering of checkout popup conditions have been met");

    if(CheckoutPopupContainerElement == null)
        return;

    CheckoutPopupContainerElement.addEventListener("click", (elem) => { CheckoutPopupContainerClick(elem); });
    CheckoutPopupBackgroundElement.addEventListener("click", (elem) => { CheckoutPopupClose(); });
}

function CheckoutPopupTimerExpired()
{

    var lastPopupDateTime = localStorage.getItem(CheckoutPopupStorageKey);

    console.log('lastPopupDateTime = ' + lastPopupDateTime);

    if (lastPopupDateTime == null) 
        return true;

    var lastPopupDateTimeNum = Number(lastPopupDateTime);
    var timeDiff = Date.now() - lastPopupDateTimeNum;
    console.log('time diff = ' + timeDiff);
    //checkout_popup_timer_limit_ms set at liquid for snippet;
    if(timeDiff > checkout_popup_timer_limit_ms)
    {
        return true;
    }
    return false;
}
function CheckoutPopupDisplay()
{ 
    if(CheckoutPopupBackgroundElement.parent !== document.body)
        document.body.prepend(CheckoutPopupBackgroundElement);
    CheckoutPopupBackgroundElement.style.display = "flex";
    localStorage.setItem(CheckoutPopupStorageKey, Date.now());
    CheckoutPopupIsOpen = true;

} 

function CheckoutPopupClose()
{
    CheckoutPopupWireUpDynamicElements();
    CheckoutPopupBackgroundElement.style.display = "none";
    CheckoutPopupOriginButton.focus();
    CheckoutPopupIsOpen = false;
}

function CheckoutPopupContainerClick(elem)
{
    elem.stopPropagation();
}

function CheckoutPopupPrimeLogic()
{
    //console.log('Date.now() = ' + Date.now());
    CheckoutPopupWireUpDynamicElements();
    if(CheckoutPopupContainerElement == null)
        return false;

    const checkout_popup_show_popup = CheckoutPopupBackgroundElement.getAttribute("checkout_popup_show_popup");
    if(checkout_popup_show_popup == 'false')
        return false;

    CheckoutPopupDisplay();
    return true;
}

function CheckoutPopupScrollButtons(direction = 1) {
  const container = document.querySelector('.nw-checkout-popup-products-container');
  const target = document.querySelector('.nw-checkout-popup-products-container .nw-checkout-popup-product');
  const productsContainer = document.querySelector('.nw-checkout-popup-products-container .nw-checkout-popup-products');
  const gapAmount = parseFloat(window.getComputedStyle(productsContainer, null).getPropertyValue("gap"));
  if (!container || !target) return;
  const baseAmount = target.offsetWidth + gapAmount;
  const amount = baseAmount * direction; 
  container.scrollLeft += amount;
}
document.addEventListener('DOMContentLoaded', () => {
        CheckoutPopupBindClick();
    });
function CheckoutPopupBindControls()
{

    const controlsToBind = document.querySelectorAll('.nw-checkout-popup-products-scroll-button');

    controlsToBind.forEach(nextControl => {
        nextControl.addEventListener('click', () => {
            console.log('Clicked or tapped!');
        });
    });

}